/**
 * Static database for the map
 * @property {number} floorIndex - Order of the floor 
 * @property {array} vertices - Vertices on map to traverse
 * @property {array} connections - Path (connection between vertices) that could be traversed through map
 */
import { facility } from 'config/constants';
import connections from './connections.json';
import vertices from './vertices.json';
import titleRotates from './titleRotates.json';

export const availableTouchDevices = [187, 114, 201, 139, 134, 89, 188, 158, 173, 177];

export default {
  floorIndex: 1,
  vertices,
  connections,
  titleRotates,
  deviceLocations: availableTouchDevices,
  [facility.elevators]: [95, 92, 86, 80],
  [facility.escalators]: [94, 91, 90, 89, 84, 79, 78],
  [facility.toilets]: [93, 88, 82, 81],
  [facility.atms]: [87],
  [facility.restArea]: [76],
  [facility.chargeArea]: [77],
  [facility.lockers]: [83],
  [facility.babyCare]: [195],
  [facility.smokeArea]: [183, 189, 190, 191, 192, 193, 194],
  [facility.infoStall]: [85],
  [facility.taxi]: [196, 197, 198, 199, 200]
};

export {vertices, titleRotates};